import { useContext } from 'react';

import { FeedbackContext } from '../context/FeedbackContext';

export const useFeedbackContext = () => {
  const context = useContext(FeedbackContext);

  if (!context) throw new Error('FeedbackContext must be used within a provider');

  return context;
};
